export { default } from "./GymSignupSuccessRoot";
